import universal from 'react-universal-component';

export default universal(() => import('./MyHuddleContainer'));



// WEBPACK FOOTER //
// ./src/app/Layout/MyHuddleLayout/index.js